import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";

import * as action from '../actions/processingStatus';
import { RootState } from "../reducers";
import { Chunk } from "../../components/ProcessingStatus/types";

type ProcessingStatus = {
  data: Array<Chunk>
}

export const useProcessingStatusState = () => {
  const processingStatus: ProcessingStatus = useSelector((state: RootState) => state.processingStatus);
  return { ...processingStatus };
};

export const useProcessingStatusDispatch = () => {
  const dispatch = useDispatch();
  return { ...bindActionCreators( { ...action }, dispatch) };
};